import React from 'react'
import ReactGA from 'react-ga'
import logo from '../images/large_tree_logo.png'

export default class extends React.Component {

    componentWillMount() {
        ReactGA.pageview(location.pathname)
    }

    render() {
        return (
            <div id="error_page" style={{textAlign: "center"}} className="layout-column layout-align-center">
                <img alt="morrisons logo" height="200" src={logo}></img>
                <div style={{color: "#004E37", fontSize: "24px", padding: "20px"}}>
                    Oops! There seems to be a problem with your account. 
                    <br/><br/>
                    To rectify this please call the MyMorri support team on 0330 041 5587 (8-6pm Monday to Friday and 10-4pm at weekends). 
                    <br/><br/>
                    Alternatively, email mymorri@morrisonsplc.co.uk for help and support.
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/pages/account_error.js